import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ConstructCourseDetailType,
  Section,
} from "../../types/course-construction";
import ApprovedInformationTab from "../approved-information-tab/approvedInformationTab";
import ViewUnitDetails from "./components/view-unit-details/ViewUnitDetails";
import "./index.scss";
import {
  getCourseDetail,
  previewCourseVersion,
} from "../../service/course-construct";
import CourseDetailView from "../course-construction/list-course-construction/course-constructor/CourseConstructView";
import { objectToQueryString } from "../../utils/getPageFromLink";
import { isEmpty, toNumber } from "lodash";
import useKeyword from "../../hooks/useKeyword";

type Props = {
  setTab?: (value: string) => void;
  tab?: string;
  isHideApprovedInformationTab?: boolean;
  preview?: boolean;
  detailDataProps?: any;
  getDetailData?: any;
  mode?: string;
};

interface Lesson {
  id: number;
  title: string;
  watched: boolean;
  videoUrl: string;
  moduleId: string;
  moduleTitle: string;
}
export default function CourseContentPage(props: Props) {
const {
    setTab,
    tab,
    isHideApprovedInformationTab,
    preview,
    detailDataProps,
    getDetailData,
    mode,
  } = props;
  const [sections, setSections] = useState<Section[]>([]);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const unitId = useKeyword("unitId");

  const [modules, setModules] = useState<any>([[]]);
  const [detailData, setDetailData] = useState<ConstructCourseDetailType>({});

  const [currentLesson, setCurrentLesson] = useState<any | null>();
  const [sectionDetail, setSectionDetail] = useState<ConstructCourseDetailType>(
    {}
  );
  const [currentSequence, setCurrentSequences] = useState<any>([]);

  const handleChangeSection = (data: Section[]) => {
    let newSections = [];
    newSections = [...sections];
    setSections([]);
    newSections = [...data];
    setSections(data);
  };

  const [loading, setLoading] = useState<boolean>(true);
  const [menuKeys, setMenuKeys] = useState<any>({
    selectedKeys: [],
    openKeys: [],
  });

  const markAsWatched = (moduleId: string, lessonId: number) => {
  };

  const selectLesson = (lesson: Lesson) => {
    setCurrentLesson(lesson);
  };

  const selectSequence = (sequence: any) => {
    setCurrentSequences(sequence.children);
  };

  const handleVideoEnd = () => {
    if (currentLesson) {
      markAsWatched(currentLesson.moduleId, currentLesson.id);
    }
  };

  const getDetailCourseData = async () => {
    setLoading(true);
    try {
      const response = await getCourseDetail(params?.id).then((res) => {
        const { data } = res.data;
        handleChangeSection(data?.sections);
        setTimeout(() => {
          setDetailData(data);
          setLoading(false);
        });
      });
    } catch (error) {}
  };

  const handleGetDetail = () => {
    getDetailCourseData();
  };

  const getInitialUnit = (sessions: any) => {
    if (!sessions?.length) return {};

    let initialUnit = {};

    for (let i = 0; i < sessions.length; i++) {
      const sequences = sessions[i]?.children;

      if (sequences?.length) {
        for (let j = 0; j < sequences.length; j++) {
          const units = sequences[j]?.children;
          if (units?.length) {
            initialUnit = units[0];
            return initialUnit;
          }
        }
      }
    }

    return isEmpty(initialUnit) ? null : initialUnit;
  };

  useEffect(() => {
    if (preview) {
      const getDetailCourseData = async () => {
        const paramUrl =
          mode === "admin"
            ? getCourseDetail(params?.id)
            : previewCourseVersion(
                Number(params?.id),
                objectToQueryString({
                  isForSv: true,
                })
              );
        try {
          await paramUrl.then((res) => {
            const data = res.data?.data;
            setSectionDetail(data);
            setMenuKeys({
              selectedKeys: [data?.sections?.[0].children[0].children[0].id],
              openKeys: [
                data?.sections?.[0].id,
                data?.sections?.[0]?.children?.[0]?.id,
              ],
            });
            if (unitId) {
              const currentActive = data?.sections?.find((section: any) => {
                return section?.children?.some((sequence: any) => {
                  return sequence?.children?.some(
                    (unit: any) => unit?.id === toNumber(unitId)
                  );
                });
              });

              if (currentActive)
                setMenuKeys({
                  selectedKeys: [unitId],
                  openKeys: [
                    currentActive?.children?.map((sequence: any) => sequence?.id),
                    currentActive.id,
                  ],
                });
            } else
              navigate(
                `${location.pathname}?unitId=${data?.sections?.[0].children[0].children[0].id}`
              );
          });
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };
      if (params?.id) {
        getDetailCourseData();
      }
    } else {
      handleGetDetail();
    }
  }, [preview, mode]);

  useEffect(() => {
    if (sectionDetail) {
      setCurrentLesson(getInitialUnit(sectionDetail?.sections));
      setModules(sectionDetail?.sections);
    }
  }, [sectionDetail]);

  if (loading) {
    return (
      <div className="layout-loading">
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      <div className="w-full">
        <div className="course-browse-layout course-wrapper flex">
          {preview ? (
            <div className="w-full">
              <div className="course-content">
                <ViewUnitDetails
                  lesson={currentLesson}
                  onVideoEnd={handleVideoEnd}
                  sectionDetail={sectionDetail}
                  modules={modules}
                  selectLesson={selectLesson}
                  selectSequence={selectSequence}
                  defaultKeys={menuKeys}
                  sequence={currentSequence}
                  mode={mode}
                />
              </div>
            </div>
          ) : (
            <div className="wrapper-course-construct">
              <section className="detail-account detail-course-construct">
                <div className="form-detail">
                  <section className="detail-account">
                    <div className="detail-course-construction">
                      <CourseDetailView detailData={detailData} />
                    </div>
                  </section>
                </div>
              </section>
            </div>
          )}
          {!isHideApprovedInformationTab && location.state?.mode !== "view" && (
            <ApprovedInformationTab
              setTab={setTab}
              tab={tab}
              getDetailDataProps={getDetailData}
              detailData={detailDataProps}
            />
          )}
        </div>
      </div>
    </>
  );
}
